export const error_animation = {
    v: '5.12.1',
    fr: 60,
    ip: 0,
    op: 150,
    w: 430,
    h: 430,
    nm: 'wired-outline-1140-error',
    ddd: 0,
    assets: [
        {
            id: 'comp_1',
            nm: 'hover-enlarge',
            fr: 60,
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'outline 2',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: {
                            a: 1,
                            k: [
                                { i: { x: [0.13], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                { i: { x: [0.129], y: [1] }, o: { x: [0.503], y: [0] }, t: 24, s: [19] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 83, s: [-20] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 111, s: [5] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 130, s: [-2] },
                                { t: 150, s: [0] }
                            ],
                            ix: 10
                        },
                        p: { a: 0, k: [215, 216.333, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [250, 251.333, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.31, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 0,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 8.755],
                                                            [-8.755, 0],
                                                            [0, -8.755],
                                                            [8.755, 0]
                                                        ],
                                                        o: [
                                                            [0, -8.755],
                                                            [8.755, 0],
                                                            [0, 8.755],
                                                            [-8.755, 0]
                                                        ],
                                                        v: [
                                                            [-15.853, 0],
                                                            [0, -15.853],
                                                            [15.853, 0],
                                                            [0, 15.853]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 22,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 20.789],
                                                            [-20.789, 0],
                                                            [0, -20.789],
                                                            [20.789, 0]
                                                        ],
                                                        o: [
                                                            [0, -20.789],
                                                            [20.789, 0],
                                                            [0, 20.789],
                                                            [-20.789, 0]
                                                        ],
                                                        v: [
                                                            [-37.641, 51.545],
                                                            [0, 13.903],
                                                            [37.641, 51.545],
                                                            [0, 89.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.272, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 46,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 11.314],
                                                            [-11.314, 0],
                                                            [0, -11.314],
                                                            [11.314, 0]
                                                        ],
                                                        o: [
                                                            [0, -11.314],
                                                            [11.314, 0],
                                                            [0, 11.314],
                                                            [-11.314, 0]
                                                        ],
                                                        v: [
                                                            [-23.573, 6.178],
                                                            [-3.087, -14.308],
                                                            [17.399, 6.178],
                                                            [-3.087, 26.664]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.423, y: 1 },
                                                o: { x: 0.586, y: 0 },
                                                t: 81,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 20.789],
                                                            [-20.789, 0],
                                                            [0, -20.789],
                                                            [20.789, 0]
                                                        ],
                                                        o: [
                                                            [0, -20.789],
                                                            [20.789, 0],
                                                            [0, 20.789],
                                                            [-20.789, 0]
                                                        ],
                                                        v: [
                                                            [-37.641, 51.545],
                                                            [0, 13.903],
                                                            [37.641, 51.545],
                                                            [0, 89.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 109,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 7.512],
                                                            [-7.512, 0],
                                                            [0, -7.512],
                                                            [7.512, 0]
                                                        ],
                                                        o: [
                                                            [0, -7.512],
                                                            [7.512, 0],
                                                            [0, 7.512],
                                                            [-7.512, 0]
                                                        ],
                                                        v: [
                                                            [-13.601, -8.118],
                                                            [0, -21.719],
                                                            [13.601, -8.118],
                                                            [0, 5.483]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 128,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 9.995],
                                                            [-9.995, 0],
                                                            [0, -9.995],
                                                            [9.995, 0]
                                                        ],
                                                        o: [
                                                            [0, -9.995],
                                                            [9.995, 0],
                                                            [0, 9.995],
                                                            [-9.995, 0]
                                                        ],
                                                        v: [
                                                            [-18.097, -0.911],
                                                            [0, -19.008],
                                                            [18.097, -0.911],
                                                            [0, 17.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                t: 148,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 8.755],
                                                            [-8.755, 0],
                                                            [0, -8.755],
                                                            [8.755, 0]
                                                        ],
                                                        o: [
                                                            [0, -8.755],
                                                            [8.755, 0],
                                                            [0, 8.755],
                                                            [-8.755, 0]
                                                        ],
                                                        v: [
                                                            [-15.853, 0],
                                                            [0, -15.853],
                                                            [15.853, 0],
                                                            [0, 15.853]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            }
                                        ],
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ind: 1,
                                    ty: 'sh',
                                    ix: 2,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.31, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 0,
                                                s: [
                                                    {
                                                        i: [
                                                            [7.383, 0],
                                                            [0, 0],
                                                            [0.36, 7.375],
                                                            [0, 0],
                                                            [-9.369, 0],
                                                            [0, 0],
                                                            [0.457, -9.358],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-7.383, 0],
                                                            [0, 0],
                                                            [-0.457, -9.358],
                                                            [0, 0],
                                                            [9.369, 0],
                                                            [0, 0],
                                                            [-0.36, 7.375]
                                                        ],
                                                        v: [
                                                            [2.704, -41.892],
                                                            [-2.704, -41.892],
                                                            [-16.531, -55.061],
                                                            [-19.358, -112.951],
                                                            [-2.981, -130.147],
                                                            [2.981, -130.147],
                                                            [19.358, -112.951],
                                                            [16.531, -55.061]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 22,
                                                s: [
                                                    {
                                                        i: [
                                                            [17.531, 0],
                                                            [0, 0],
                                                            [0.855, 17.51],
                                                            [0, 0],
                                                            [-22.247, 0],
                                                            [0, 0],
                                                            [1.085, -22.22],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-17.531, 0],
                                                            [0, 0],
                                                            [-1.085, -22.22],
                                                            [0, 0],
                                                            [22.247, 0],
                                                            [0, 0],
                                                            [-0.855, 17.51]
                                                        ],
                                                        v: [
                                                            [6.42, -47.926],
                                                            [-6.42, -47.926],
                                                            [-39.252, -79.194],
                                                            [-45.964, -216.65],
                                                            [-7.078, -257.48],
                                                            [7.078, -257.48],
                                                            [45.964, -216.65],
                                                            [39.252, -79.194]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.272, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 46,
                                                s: [
                                                    {
                                                        i: [
                                                            [9.541, 0],
                                                            [0, 0],
                                                            [0.465, 9.53],
                                                            [0, 0],
                                                            [-12.108, 0],
                                                            [0, 0],
                                                            [0.59, -12.093],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-9.541, 0],
                                                            [0, 0],
                                                            [-0.59, -12.093],
                                                            [0, 0],
                                                            [12.108, 0],
                                                            [0, 0],
                                                            [-0.465, 9.53]
                                                        ],
                                                        v: [
                                                            [0.407, -47.958],
                                                            [-6.581, -47.958],
                                                            [-24.45, -64.975],
                                                            [-28.102, -139.784],
                                                            [-6.939, -162.005],
                                                            [0.765, -162.005],
                                                            [21.928, -139.784],
                                                            [18.276, -64.975]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.423, y: 1 },
                                                o: { x: 0.586, y: 0 },
                                                t: 81,
                                                s: [
                                                    {
                                                        i: [
                                                            [17.531, 0],
                                                            [0, 0],
                                                            [0.855, 17.51],
                                                            [0, 0],
                                                            [-22.247, 0],
                                                            [0, 0],
                                                            [1.085, -22.22],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-17.531, 0],
                                                            [0, 0],
                                                            [-1.085, -22.22],
                                                            [0, 0],
                                                            [22.247, 0],
                                                            [0, 0],
                                                            [-0.855, 17.51]
                                                        ],
                                                        v: [
                                                            [6.42, -47.926],
                                                            [-6.42, -47.926],
                                                            [-39.252, -79.194],
                                                            [-45.964, -216.65],
                                                            [-7.078, -257.48],
                                                            [7.078, -257.48],
                                                            [45.964, -216.65],
                                                            [39.252, -79.194]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 109,
                                                s: [
                                                    {
                                                        i: [
                                                            [6.335, 0],
                                                            [0, 0],
                                                            [0.309, 6.327],
                                                            [0, 0],
                                                            [-8.038, 0],
                                                            [0, 0],
                                                            [0.392, -8.029],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-6.335, 0],
                                                            [0, 0],
                                                            [-0.392, -8.029],
                                                            [0, 0],
                                                            [8.038, 0],
                                                            [0, 0],
                                                            [-0.309, 6.327]
                                                        ],
                                                        v: [
                                                            [2.32, -44.059],
                                                            [-2.32, -44.059],
                                                            [-14.183, -55.357],
                                                            [-16.608, -105.025],
                                                            [-2.558, -119.778],
                                                            [2.558, -119.778],
                                                            [16.608, -105.025],
                                                            [14.183, -55.357]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 128,
                                                s: [
                                                    {
                                                        i: [
                                                            [8.428, 0],
                                                            [0, 0],
                                                            [0.411, 8.418],
                                                            [0, 0],
                                                            [-10.696, 0],
                                                            [0, 0],
                                                            [0.522, -10.683],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-8.428, 0],
                                                            [0, 0],
                                                            [-0.522, -10.683],
                                                            [0, 0],
                                                            [10.696, 0],
                                                            [0, 0],
                                                            [-0.411, 8.418]
                                                        ],
                                                        v: [
                                                            [3.087, -48.733],
                                                            [-3.087, -48.733],
                                                            [-18.871, -63.766],
                                                            [-22.098, -129.851],
                                                            [-3.403, -149.48],
                                                            [3.403, -149.48],
                                                            [22.098, -129.851],
                                                            [18.871, -63.766]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                t: 148,
                                                s: [
                                                    {
                                                        i: [
                                                            [7.383, 0],
                                                            [0, 0],
                                                            [0.36, 7.375],
                                                            [0, 0],
                                                            [-9.369, 0],
                                                            [0, 0],
                                                            [0.457, -9.358],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-7.383, 0],
                                                            [0, 0],
                                                            [-0.457, -9.358],
                                                            [0, 0],
                                                            [9.369, 0],
                                                            [0, 0],
                                                            [-0.36, 7.375]
                                                        ],
                                                        v: [
                                                            [2.704, -41.892],
                                                            [-2.704, -41.892],
                                                            [-16.531, -55.061],
                                                            [-19.358, -112.951],
                                                            [-2.981, -130.147],
                                                            [2.981, -130.147],
                                                            [19.358, -112.951],
                                                            [16.531, -55.061]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            }
                                        ],
                                        ix: 2
                                    },
                                    nm: 'Path 2',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [0.208, 0.8, 0.729, 1],
                                        ix: 3,
                                        x: "var $bm_rt;\n$bm_rt = comp('wired-outline-1140-error').layer('control').effect('secondary')('Color');"
                                    },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 0,
                                        k: 12,
                                        ix: 5,
                                        x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-1140-error').layer('control').effect('stroke')('Menu'));"
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: '.secondary',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                    cl: 'secondary'
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [250, 335.48], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Group 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 844,
                    st: 0,
                    ct: 1,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: 'mask',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: {
                            a: 1,
                            k: [
                                { i: { x: [0.13], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                                { i: { x: [0.129], y: [1] }, o: { x: [0.503], y: [0] }, t: 24, s: [19] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 83, s: [-20] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 111, s: [5] },
                                { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 130, s: [-2] },
                                { t: 150, s: [0] }
                            ],
                            ix: 10
                        },
                        p: { a: 0, k: [215, 216.333, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [250, 251.333, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.31, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 0,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 8.755],
                                                            [-8.755, 0],
                                                            [0, -8.755],
                                                            [8.755, 0]
                                                        ],
                                                        o: [
                                                            [0, -8.755],
                                                            [8.755, 0],
                                                            [0, 8.755],
                                                            [-8.755, 0]
                                                        ],
                                                        v: [
                                                            [-15.853, 0],
                                                            [0, -15.853],
                                                            [15.853, 0],
                                                            [0, 15.853]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 22,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 20.789],
                                                            [-20.789, 0],
                                                            [0, -20.789],
                                                            [20.789, 0]
                                                        ],
                                                        o: [
                                                            [0, -20.789],
                                                            [20.789, 0],
                                                            [0, 20.789],
                                                            [-20.789, 0]
                                                        ],
                                                        v: [
                                                            [-37.641, 51.545],
                                                            [0, 13.903],
                                                            [37.641, 51.545],
                                                            [0, 89.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.272, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 46,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 11.314],
                                                            [-11.314, 0],
                                                            [0, -11.314],
                                                            [11.314, 0]
                                                        ],
                                                        o: [
                                                            [0, -11.314],
                                                            [11.314, 0],
                                                            [0, 11.314],
                                                            [-11.314, 0]
                                                        ],
                                                        v: [
                                                            [-23.573, 6.178],
                                                            [-3.087, -14.308],
                                                            [17.399, 6.178],
                                                            [-3.087, 26.664]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.423, y: 1 },
                                                o: { x: 0.586, y: 0 },
                                                t: 81,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 20.789],
                                                            [-20.789, 0],
                                                            [0, -20.789],
                                                            [20.789, 0]
                                                        ],
                                                        o: [
                                                            [0, -20.789],
                                                            [20.789, 0],
                                                            [0, 20.789],
                                                            [-20.789, 0]
                                                        ],
                                                        v: [
                                                            [-37.641, 51.545],
                                                            [0, 13.903],
                                                            [37.641, 51.545],
                                                            [0, 89.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 109,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 7.512],
                                                            [-7.512, 0],
                                                            [0, -7.512],
                                                            [7.512, 0]
                                                        ],
                                                        o: [
                                                            [0, -7.512],
                                                            [7.512, 0],
                                                            [0, 7.512],
                                                            [-7.512, 0]
                                                        ],
                                                        v: [
                                                            [-13.601, -8.118],
                                                            [0, -21.719],
                                                            [13.601, -8.118],
                                                            [0, 5.483]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 128,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 9.995],
                                                            [-9.995, 0],
                                                            [0, -9.995],
                                                            [9.995, 0]
                                                        ],
                                                        o: [
                                                            [0, -9.995],
                                                            [9.995, 0],
                                                            [0, 9.995],
                                                            [-9.995, 0]
                                                        ],
                                                        v: [
                                                            [-18.097, -0.911],
                                                            [0, -19.008],
                                                            [18.097, -0.911],
                                                            [0, 17.186]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                t: 148,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 8.755],
                                                            [-8.755, 0],
                                                            [0, -8.755],
                                                            [8.755, 0]
                                                        ],
                                                        o: [
                                                            [0, -8.755],
                                                            [8.755, 0],
                                                            [0, 8.755],
                                                            [-8.755, 0]
                                                        ],
                                                        v: [
                                                            [-15.853, 0],
                                                            [0, -15.853],
                                                            [15.853, 0],
                                                            [0, 15.853]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            }
                                        ],
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ind: 1,
                                    ty: 'sh',
                                    ix: 2,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.31, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 0,
                                                s: [
                                                    {
                                                        i: [
                                                            [7.383, 0],
                                                            [0, 0],
                                                            [0.36, 7.375],
                                                            [0, 0],
                                                            [-9.369, 0],
                                                            [0, 0],
                                                            [0.457, -9.358],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-7.383, 0],
                                                            [0, 0],
                                                            [-0.457, -9.358],
                                                            [0, 0],
                                                            [9.369, 0],
                                                            [0, 0],
                                                            [-0.36, 7.375]
                                                        ],
                                                        v: [
                                                            [2.704, -41.892],
                                                            [-2.704, -41.892],
                                                            [-16.531, -55.061],
                                                            [-19.358, -112.951],
                                                            [-2.981, -130.147],
                                                            [2.981, -130.147],
                                                            [19.358, -112.951],
                                                            [16.531, -55.061]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 22,
                                                s: [
                                                    {
                                                        i: [
                                                            [17.531, 0],
                                                            [0, 0],
                                                            [0.855, 17.51],
                                                            [0, 0],
                                                            [-22.247, 0],
                                                            [0, 0],
                                                            [1.085, -22.22],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-17.531, 0],
                                                            [0, 0],
                                                            [-1.085, -22.22],
                                                            [0, 0],
                                                            [22.247, 0],
                                                            [0, 0],
                                                            [-0.855, 17.51]
                                                        ],
                                                        v: [
                                                            [6.42, -47.926],
                                                            [-6.42, -47.926],
                                                            [-39.252, -79.194],
                                                            [-45.964, -216.65],
                                                            [-7.078, -257.48],
                                                            [7.078, -257.48],
                                                            [45.964, -216.65],
                                                            [39.252, -79.194]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.272, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 46,
                                                s: [
                                                    {
                                                        i: [
                                                            [9.541, 0],
                                                            [0, 0],
                                                            [0.465, 9.53],
                                                            [0, 0],
                                                            [-12.108, 0],
                                                            [0, 0],
                                                            [0.59, -12.093],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-9.541, 0],
                                                            [0, 0],
                                                            [-0.59, -12.093],
                                                            [0, 0],
                                                            [12.108, 0],
                                                            [0, 0],
                                                            [-0.465, 9.53]
                                                        ],
                                                        v: [
                                                            [0.407, -47.958],
                                                            [-6.581, -47.958],
                                                            [-24.45, -64.975],
                                                            [-28.102, -139.784],
                                                            [-6.939, -162.005],
                                                            [0.765, -162.005],
                                                            [21.928, -139.784],
                                                            [18.276, -64.975]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.423, y: 1 },
                                                o: { x: 0.586, y: 0 },
                                                t: 81,
                                                s: [
                                                    {
                                                        i: [
                                                            [17.531, 0],
                                                            [0, 0],
                                                            [0.855, 17.51],
                                                            [0, 0],
                                                            [-22.247, 0],
                                                            [0, 0],
                                                            [1.085, -22.22],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-17.531, 0],
                                                            [0, 0],
                                                            [-1.085, -22.22],
                                                            [0, 0],
                                                            [22.247, 0],
                                                            [0, 0],
                                                            [-0.855, 17.51]
                                                        ],
                                                        v: [
                                                            [6.42, -47.926],
                                                            [-6.42, -47.926],
                                                            [-39.252, -79.194],
                                                            [-45.964, -216.65],
                                                            [-7.078, -257.48],
                                                            [7.078, -257.48],
                                                            [45.964, -216.65],
                                                            [39.252, -79.194]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 109,
                                                s: [
                                                    {
                                                        i: [
                                                            [6.335, 0],
                                                            [0, 0],
                                                            [0.309, 6.327],
                                                            [0, 0],
                                                            [-8.038, 0],
                                                            [0, 0],
                                                            [0.392, -8.029],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-6.335, 0],
                                                            [0, 0],
                                                            [-0.392, -8.029],
                                                            [0, 0],
                                                            [8.038, 0],
                                                            [0, 0],
                                                            [-0.309, 6.327]
                                                        ],
                                                        v: [
                                                            [2.32, -44.059],
                                                            [-2.32, -44.059],
                                                            [-14.183, -55.357],
                                                            [-16.608, -105.025],
                                                            [-2.558, -119.778],
                                                            [2.558, -119.778],
                                                            [16.608, -105.025],
                                                            [14.183, -55.357]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 128,
                                                s: [
                                                    {
                                                        i: [
                                                            [8.428, 0],
                                                            [0, 0],
                                                            [0.411, 8.418],
                                                            [0, 0],
                                                            [-10.696, 0],
                                                            [0, 0],
                                                            [0.522, -10.683],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-8.428, 0],
                                                            [0, 0],
                                                            [-0.522, -10.683],
                                                            [0, 0],
                                                            [10.696, 0],
                                                            [0, 0],
                                                            [-0.411, 8.418]
                                                        ],
                                                        v: [
                                                            [3.087, -48.733],
                                                            [-3.087, -48.733],
                                                            [-18.871, -63.766],
                                                            [-22.098, -129.851],
                                                            [-3.403, -149.48],
                                                            [3.403, -149.48],
                                                            [22.098, -129.851],
                                                            [18.871, -63.766]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                t: 148,
                                                s: [
                                                    {
                                                        i: [
                                                            [7.383, 0],
                                                            [0, 0],
                                                            [0.36, 7.375],
                                                            [0, 0],
                                                            [-9.369, 0],
                                                            [0, 0],
                                                            [0.457, -9.358],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [-7.383, 0],
                                                            [0, 0],
                                                            [-0.457, -9.358],
                                                            [0, 0],
                                                            [9.369, 0],
                                                            [0, 0],
                                                            [-0.36, 7.375]
                                                        ],
                                                        v: [
                                                            [2.704, -41.892],
                                                            [-2.704, -41.892],
                                                            [-16.531, -55.061],
                                                            [-19.358, -112.951],
                                                            [-2.981, -130.147],
                                                            [2.981, -130.147],
                                                            [19.358, -112.951],
                                                            [16.531, -55.061]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            }
                                        ],
                                        ix: 2
                                    },
                                    nm: 'Path 2',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [250, 335.48], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Group 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 844,
                    st: 0,
                    ct: 1,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: 'outline',
                    tt: 2,
                    tp: 2,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [215, 215, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.181, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 0,
                                                s: [
                                                    {
                                                        i: [
                                                            [-5.016, -8.689],
                                                            [0, 0],
                                                            [10.033, 0],
                                                            [0, 0],
                                                            [-5.016, 8.689],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [5.016, 8.689],
                                                            [0, 0],
                                                            [-10.033, 0],
                                                            [0, 0],
                                                            [5.016, -8.689]
                                                        ],
                                                        v: [
                                                            [11.287, -126.916],
                                                            [150.313, 113.883],
                                                            [139.026, 133.433],
                                                            [-139.026, 133.433],
                                                            [-150.313, 113.883],
                                                            [-11.287, -126.916]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 24,
                                                s: [
                                                    {
                                                        i: [
                                                            [-4.328, -7.496],
                                                            [0, 0],
                                                            [8.655, 0],
                                                            [0, 0],
                                                            [-4.328, 7.496],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [4.328, 7.496],
                                                            [0, 0],
                                                            [-8.655, 0],
                                                            [0, 0],
                                                            [4.328, -7.496]
                                                        ],
                                                        v: [
                                                            [9.737, -109.638],
                                                            [129.672, 98.096],
                                                            [119.935, 114.961],
                                                            [-119.935, 114.961],
                                                            [-129.672, 98.096],
                                                            [-9.737, -109.638]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.43, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 48,
                                                s: [
                                                    {
                                                        i: [
                                                            [-4.747, -8.223],
                                                            [0, 0],
                                                            [9.495, 0],
                                                            [0, 0],
                                                            [-4.747, 8.223],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [4.747, 8.223],
                                                            [0, 0],
                                                            [-9.495, 0],
                                                            [0, 0],
                                                            [4.747, -8.223]
                                                        ],
                                                        v: [
                                                            [10.682, -120.169],
                                                            [142.253, 107.719],
                                                            [131.571, 126.22],
                                                            [-131.571, 126.22],
                                                            [-142.253, 107.719],
                                                            [-10.682, -120.169]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.467, y: 1 },
                                                o: { x: 0.696, y: 0 },
                                                t: 83,
                                                s: [
                                                    {
                                                        i: [
                                                            [-4.328, -7.496],
                                                            [0, 0],
                                                            [8.655, 0],
                                                            [0, 0],
                                                            [-4.328, 7.496],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [4.328, 7.496],
                                                            [0, 0],
                                                            [-8.655, 0],
                                                            [0, 0],
                                                            [4.328, -7.496]
                                                        ],
                                                        v: [
                                                            [9.737, -109.638],
                                                            [129.672, 98.096],
                                                            [119.935, 114.961],
                                                            [-119.935, 114.961],
                                                            [-129.672, 98.096],
                                                            [-9.737, -109.638]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 111,
                                                s: [
                                                    {
                                                        i: [
                                                            [-5.628, -9.748],
                                                            [0, 0],
                                                            [11.256, 0],
                                                            [0, 0],
                                                            [-5.628, 9.748],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [5.628, 9.748],
                                                            [0, 0],
                                                            [-11.256, 0],
                                                            [0, 0],
                                                            [5.628, -9.748]
                                                        ],
                                                        v: [
                                                            [12.663, -142.252],
                                                            [168.633, 127.896],
                                                            [155.97, 149.828],
                                                            [-155.97, 149.828],
                                                            [-168.633, 127.896],
                                                            [-12.662, -142.252]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 130,
                                                s: [
                                                    {
                                                        i: [
                                                            [-4.715, -8.167],
                                                            [0, 0],
                                                            [9.43, 0],
                                                            [0, 0],
                                                            [-4.715, 8.167],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [4.715, 8.167],
                                                            [0, 0],
                                                            [-9.43, 0],
                                                            [0, 0],
                                                            [4.715, -8.167]
                                                        ],
                                                        v: [
                                                            [10.609, -119.359],
                                                            [141.285, 106.978],
                                                            [130.676, 125.354],
                                                            [-130.676, 125.354],
                                                            [-141.285, 106.978],
                                                            [-10.609, -119.359]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            },
                                            {
                                                t: 150,
                                                s: [
                                                    {
                                                        i: [
                                                            [-5.016, -8.689],
                                                            [0, 0],
                                                            [10.033, 0],
                                                            [0, 0],
                                                            [-5.016, 8.689],
                                                            [0, 0]
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [5.016, 8.689],
                                                            [0, 0],
                                                            [-10.033, 0],
                                                            [0, 0],
                                                            [5.016, -8.689]
                                                        ],
                                                        v: [
                                                            [11.287, -126.916],
                                                            [150.313, 113.883],
                                                            [139.026, 133.433],
                                                            [-139.026, 133.433],
                                                            [-150.313, 113.883],
                                                            [-11.287, -126.916]
                                                        ],
                                                        c: true
                                                    }
                                                ]
                                            }
                                        ],
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [0.114, 0.192, 0.275, 1],
                                        ix: 3,
                                        x: "var $bm_rt;\n$bm_rt = comp('wired-outline-1140-error').layer('control').effect('primary')('Color');"
                                    },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 0,
                                        k: 12,
                                        ix: 5,
                                        x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-1140-error').layer('control').effect('stroke')('Menu'));"
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: '.primary',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                    cl: 'primary'
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 844,
                    st: 0,
                    ct: 1,
                    bm: 0
                }
            ]
        }
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 3,
            nm: 'control',
            sr: 1,
            ks: {
                o: { a: 0, k: 0, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [0, 0], ix: 2, l: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
            },
            ao: 0,
            ef: [
                {
                    ty: 5,
                    nm: 'stroke',
                    np: 3,
                    mn: 'Pseudo/@@qS4hRvA2RiGH7TG84WuZRg',
                    ix: 1,
                    en: 1,
                    ef: [{ ty: 7, nm: 'Menu', mn: 'Pseudo/@@qS4hRvA2RiGH7TG84WuZRg-0001', ix: 1, v: { a: 0, k: 2, ix: 1 } }]
                },
                {
                    ty: 5,
                    nm: 'primary',
                    np: 3,
                    mn: 'ADBE Color Control',
                    ix: 2,
                    en: 1,
                    ef: [{ ty: 2, nm: 'Color', mn: 'ADBE Color Control-0001', ix: 1, v: { a: 0, k: [0.114, 0.192, 0.275], ix: 1 } }]
                },
                {
                    ty: 5,
                    nm: 'secondary',
                    np: 3,
                    mn: 'ADBE Color Control',
                    ix: 3,
                    en: 1,
                    ef: [{ ty: 2, nm: 'Color', mn: 'ADBE Color Control-0001', ix: 1, v: { a: 0, k: [0.208, 0.8, 0.729], ix: 1 } }]
                }
            ],
            ip: 0,
            op: 411,
            st: 0,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 0,
            nm: 'hover-enlarge',
            refId: 'comp_1',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [215, 215, 0], ix: 2, l: 2 },
                a: { a: 0, k: [215, 215, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
            },
            ao: 0,
            w: 430,
            h: 430,
            ip: 0,
            op: 160,
            st: 0,
            bm: 0
        }
    ],
    markers: [{ tm: 0, cm: 'default:hover-enlarge', dr: 150 }],
    props: {}
};
